import React, { createContext, useState } from "react";

// Araçlarla ilgili verileri ve işlemleri paylaşmak için context oluşturuluyor
export const VehiclesContext = createContext();

export const VehiclesProvider = ({ children }) => {
  // Araçlar listesi state'i
  const [vehiclesList, setVehiclesList] = useState([
    { id: 1, brand: "Toyota", model: "Corolla", plate: "34ABC01", dealerName: "X Bayi", description: "Otomobil" },
    { id: 2, brand: "Ford", model: "Transit", plate: "06XYZ12", dealerName: "Y Bayi", description: "Kargo aracı" },
  ]);

  // Yeni araç ekleme fonksiyonu
  const addVehicle = (vehicle) => {
    const newId = vehiclesList.length > 0 ? Math.max(...vehiclesList.map((v) => v.id)) + 1 : 1;
    setVehiclesList((prev) => [...prev, { ...vehicle, id: newId }]);
  };

  // Mevcut aracı güncelleme fonksiyonu
  const updateVehicle = (id, updatedData) => {
    setVehiclesList((prev) =>
      prev.map((v) => (v.id === id ? { ...v, ...updatedData } : v))
    );
  };

  // Araç silme fonksiyonu
  const deleteVehicle = (id) => {
    setVehiclesList((prev) => prev.filter((v) => v.id !== id));
  };

  // Context üzerinden değerler paylaşılıyor
  return (
    <VehiclesContext.Provider
      value={{
        vehiclesList,   
        addVehicle,     
        updateVehicle,  
        deleteVehicle,  
      }}
    >
      {children}  {/* Context'i kullanan tüm bileşenler */}
    </VehiclesContext.Provider>
  );
};
